import { CmsDevicePreviewToggle } from "./CmsDevicePreviewToggle";
import { CmsLeftNavigator } from "./CmsLeftNavigator";
import { CmsOverflowMenu } from "./CmsOverflowMenu";
import { CmsSaveStatusBar } from "./CmsSaveStatusBar";
import type { CmsMenuItem } from "../types";

interface ShellCallbacks {
    onMenuAction: (item: CmsMenuItem, trigger: HTMLElement) => void;
}

export class CmsBuilderShell {
    readonly #overflow = new CmsOverflowMenu();
    readonly #left: CmsLeftNavigator;
    readonly #save: CmsSaveStatusBar;
    readonly #device: CmsDevicePreviewToggle;

    constructor(private readonly root: HTMLElement, private readonly callbacks: ShellCallbacks) {
        this.#left = new CmsLeftNavigator(root);
        this.#save = new CmsSaveStatusBar(root);
        this.#device = new CmsDevicePreviewToggle(root);
    }

    init(): void {
        this.#left.init();
        this.#save.init();
        this.#device.init();
        this.root.addEventListener("click", (event) => {
            const trigger = (event.target as HTMLElement | null)?.closest<HTMLElement>("[data-cms-overflow-trigger]");
            if (!trigger || !this.root.contains(trigger)) return;
            event.preventDefault();
            event.stopPropagation();
            this.#overflow.toggle(trigger, this.#items(trigger), (item, source) => this.callbacks.onMenuAction(item, source));
        });
        this.root.addEventListener("cms:canvas-updated", () => this.#left.refreshLayers());
    }

    destroy(): void {
        this.#overflow.destroy();
    }

    #items(trigger: HTMLElement): CmsMenuItem[] {
        try {
            const parsed = JSON.parse(trigger.dataset.cmsOverflowActions ?? "[]") as CmsMenuItem[];
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    }
}
